import React from "react";
import Success from "../components/uploadSuccess/SuccessPage";

const UploadedGame = () => {
  return (
    <div className="Crowdfunding_1 flex h-screen items-center">
      <div className="">
        <Success />
      </div>
    </div>
  );
};

export default UploadedGame;